import { CloudSyncIcon } from '@tableau/icons/CloudSyncIcon';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { ContentRelayPlansResourceQuery } from '~src/contentRelay/ResourceQuery/ContentRelayPlansResourceQuery';
import { ContentRelayPlanCard } from '~src/contentRelay/space/ContentRelayPlanCard';
import {
  ContentTypeFilterClause,
  ExplorableItemDefinition,
  SpaceDefinition,
} from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getNoDefaultFilters } from '~src/spacesPlatform/contentDefinitions/getDefaultFilters';
import { ContentFiltersKeys } from '~src/spacesPlatform/models/ContentFilters';

export const ContentRelayPlanDefinition: SpaceDefinition<'contentRelayPlan'> & ExplorableItemDefinition = {
  itemType: 'contentRelayPlan',
  contentType: 'contentRelayPlan',
  singularName: Messages.contentRelayPlan,
  pluralName: Messages.contentRelayPlans,
  emptyStateMessage: Messages.contentRelayPlansEmptyMessage,
  contentFilterKeys: [
    ContentFiltersKeys.search,
  ],
  defaultFilters: getNoDefaultFilters,
  cardComponent: ContentRelayPlanCard,
  listViewIconType: CloudSyncIcon,
  filterClause: ServerFilterClauses.ContentType(['contentRelayPlan']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return new ContentRelayPlansResourceQuery();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list', 'thumbnail'],
  contentSpaceUrl: (urls, _contentId, luid) => urls.contentRelayPlanUrl(luid),
  headerIconPath: () => undefined,
};
